import { get } from "db/api";

export const exportSubscriptions = async () => {
  try {
    const response = await get("/export-subscriptions");
    const data = await response.json();

    if (!response.ok) {
      console.error("Error en la función:", data.error);
      return;
    }
  } catch (error) {
    console.error("Error inesperado:", error.message);
  }
};
